import { render } from "./Shop.vue?vue&type=template&id=68a90ff2"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__